import type { SentryModule } from '../types';

export const MODULE_HEADING: Record<SentryModule, string> = {
  auth: 'Authentication',
  login: 'Login',
  signup: 'Signup',
  landing: 'Landing',
  home: 'Home',
  onboarding: 'Onboarding',
  payment_links: 'Payment Links',
  payment_forms: 'Payment Forms',
  payment_buttons: 'Payment Buttons',
  payments: 'Payments',
  settlements: 'Settlements',
  payouts: 'Payouts',
  developers: 'Developers',
  disputes: 'Disputes',
  reports: 'Reports',
  orders: 'Orders',
  refunds: 'Refunds',
  summary: 'Summary',
  settings: 'Settings',
  offers: 'Offers',
  one_click_checkout: 'One-Click Checkout',
  easy_split: 'Easy Split',
  softpos: 'SoftPOS',
  customers: 'Customers',
  customisation: 'Customisation',
  subscriptions: 'Subscriptions',
  risk_shield: 'Risk Shield',
  vba: 'VBA Accounts',
  insights: 'Insights',
  suspicious: 'Suspicious Transaction',
  apps: 'Apps',
  downtimes: 'DownTimes',
  embedded_components: 'Embedded Components',
  flowwise: 'Flowwise',
  relay: 'Relay',
  bbps: 'BBPS',
  vswebapp: 'VSWebApp',
  cross_border: 'Cross Border',
  international_payment_gateway: 'International Payment Gateway',
  global_collection: 'Global Collection',
};

export const CONTAINER_HEADING: Record<string, string> = {
  LOGIN: 'Login',
  SIGNUP: 'Signup',
  PAYMENT_LINKS: 'Payment Links',
  PAYMENT_FORMS: 'Payment Forms',
  PAYMENT_BUTTONS: 'Payment Buttons',
  TRANSACTIONS: 'Payments',
  SETTLEMENTS: 'Settlements',
  DEVELOPERS: 'Developers',
  REPORTS: 'Reports',
  SUMMARY: 'Home',
  ANALYTICS_V2: 'Insights',
  APPS: 'Apps',
  STATUS_PAGE: 'DownTimes',
  EMBEDDABLE_COMPONENTS: 'Embedded Components',
  VBA_CONFIGURATION: 'VBA Accounts',
  ROUTER: 'Flowwise',
  GATEWAY_PLUS: 'Flowwise',
  ROUTER_ANALYTICS: 'Flowwise',
  SOFTPOS: 'SoftPOS',
  RISKSHIELD: 'Risk Shield',
  CHECKOUT_ONE: 'One-Click Checkout',
  OFFERS: 'Offers',
  CUSTOMERS: 'Customers',
  EASY_SPLIT: 'Easy Split',
  SUBSCRIPTIONS: 'Subscriptions',
  SETTINGS: 'Settings',
  BRANDING: 'Customisation',
};
